export default __webpack_public_path__ + "static/media/logo.d0b79cd1.svg";